import { ContentArticle } from './article/content-article';
import { ContentType } from './generated/content';

type ContentPageProps = {
  readonly type: ContentType;
  readonly id: string;
};

const handleUnknown = (type: never): never => {
  throw new Error('Unknown type: ' + type);
};

const ContentRender = ({ type, id }: ContentPageProps) => {
  switch (type) {
    case ContentType.Article:
      return <ContentArticle id={id} />;
    default:
      return handleUnknown(type);
  }
};

const ContentPage = (props: ContentPageProps) => {
  return (
    <div className="form-container">
      <ContentRender {...props} />
    </div>
  );
};

export { ContentPage };
